export default __webpack_public_path__ + "static/media/Sample Image.733476b7.jpg";